
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/singles",
      function () {
        return require("private-next-pages/singles.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/singles"])
      });
    }
  